import React, {Component} from 'react'
import RegistrationWorkerSplash from './RegistrationWorkerSplash'

export default class RegistrationWorkerSplashContainer extends Component {
    render() {
        return(<RegistrationWorkerSplash />);
    }
}


// WEBPACK FOOTER //
// ./src/containers/Registration/WorkerSplash/RegistrationWorkerSplashContainer.js